module.exports = __webpack_public_path__ + "static/media/  (67).c2f42616.jpg";